let _initProto;
function _applyDecs(e, t, n, r, o, i) { var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length; function g(t, n, r) { return function (o, i) { n && (i = o, o = e); for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []); return r ? i : o; }; } function b(e, t, n, r) { if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined")); return e; } function applyDec(e, t, n, r, o, i, u, s, f, l, p) { function d(e) { if (!p(e)) throw new TypeError("Attempted to access private element on non-instance"); } var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o; function I(t, n, r) { return function (o, i) { return n && (i = o, o = e), r && r(o), P[t].call(o, i); }; } if (!w) { var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value"; if (f ? (l || D ? P = { get: _setFunctionName(function () { return v(this); }, r, "get"), set: function (e) { t[4](this, e); } } : P[F] = v, l || _setFunctionName(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) { if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet"); y[+s][r] = o < 3 ? 1 : o; } } for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) { var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = { kind: ["field", "accessor", "method", "getter", "setter", "class"][o], name: r, metadata: a, addInitializer: function (e, t) { if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished"); b(t, "An initializer", "be", !0), i.push(t); }.bind(null, A) }; if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function (e) { return r in e; } }, j || (c.get = f ? E ? function (e) { return d(e), P.value; } : I("get", 0, d) : function (e) { return e[r]; }), E || S || (c.set = f ? I("set", 0, d) : function (e, t) { e[r] = t; }), N = T.call(z, D ? { get: P.get, set: P.set } : P[F], H), A.v = 1, D) { if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined"); } else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N); } return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N; } function w(e) { return m(e, d, { configurable: !0, enumerable: !0, value: a }); } return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function (e) { e && f.push(g(e)); }, p = function (t, r) { for (var i = 0; i < n.length; i++) { var a = n[i], c = a[1], l = 7 & c; if ((8 & c) == t && !l == r) { var p = a[2], d = !!a[3], m = 16 & c; applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function (t) { return _checkInRHS(t) === e; } : o); } } }, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), { e: c, get c() { var n = []; return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)]; } }; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _setFunctionName(e, t, n) { "symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : ""); try { Object.defineProperty(e, "name", { configurable: !0, value: n ? n + " " + t : t }); } catch (e) {} return e; }
function _checkInRHS(e) { if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null")); return e; }
import template from "./view-fermentation-new.html";
import css from "./view-fermentation-new.css";
import Dialog from "dialog";
import { ui } from "webcomponent";
import moment from "moment";
import { DateTimePicker } from "picker";
import Datatable from "datatable";
import { Textbox } from "gui";
import ColorPicker from "../../controls/textbox-colorpicker.js";

/*
	this dialog simply generates form data from its content
    and loads it back

    form data parameters also conrol the process of fermentation
    for example if form.running = true then the fermentation will start

    generated tabular data look like this: (https://www.w3.org/TR/csv2json/)
    [{ 
      "countryCode": "AD", 
      "latitude": "42.5", 
      "longitude": "1.6", 
      "name": "Andorra" 
    }, { 
      "countryCode": "AE", 
      "latitude": "23.4", 
      "longitude": "53.8", 
      "name": "United Arab Emirates" 
    }, { 
      "countryCode": "AF", 
      "latitude": "33.9", 
      "longitude": "67.7", 
      "name": "Afghanistan" 
    }]
*/

export default class MyDialog extends Dialog {
  static {
    [_initProto] = _applyDecs(this, [], [[ui.click("#buttonSave"), 2, "buttonSave_click"], [ui.click("#buttonAddInoculum"), 2, "buttonAddInoculum_click"], [ui.click("#buttonRemoveInoculum"), 2, "buttonRemoveInoculum_click"], [ui.click("#buttonAddGrowthData"), 2, "buttonAddGrowthData_click"], [ui.click("#buttonRemoveGrowthData"), 2, "buttonRemoveGrowthData_click"], [ui.click("#buttonAddAnalyticalData"), 2, "buttonAddAnalyticalData_click"], [ui.click("#buttonRemoveAnalyticalData"), 2, "buttonRemoveAnalyticalData_click"], [ui.click("#buttonAddProduct"), 2, "buttonAddProduct_click"], [ui.click("#buttonRemoveProduct"), 2, "buttonRemoveProduct_click"], [ui.click("#buttonClose"), 2, "buttonClose_click"], [ui.change("#datetimepickerEndDate"), 2, "datetimepickerEndDate_change"], [ui.change("#spinnerDuration"), 2, "spinnerDuration_change"]], 0, void 0, Dialog).e;
  }
  static get template() {
    return template;
  }
  static get css() {
    return css;
  }
  static {
    customElements.define("biocore-fermentation-new", MyDialog);
  }
  async connectedCallback(...args) {
    await super.connectedCallback(...args);
    console.log(this.fid);
    if (!this.fid) return;
    const resp = await fetch(`/api/pc/fermentations/${this.fid}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });
    if (!resp.ok) throw new Error(`${resp.status}`);
    let result = await resp.json();
    this._textboxID.value = this.fid;
    if (result.operator) this.textboxOperator.value = result.operator;
    if (result.created) this.textboxCreated.value = result.created;
    this._spinnerTargetTemperature.value = result.targetTemperature;
    this._spinnerTargetPH.value = result.targetPH;
    this.spinnerPHDeadband.value = result.pHDeadband;
    this._spinnerFeedRate.value = result.feedRate;
    this._spinnerOxygenLevel.value = result.oxygenLevel;
    this._spinnerAirFlow.value = result.airFlow;
    this.dateTimeSunrise.value = result.sunrise;
    this.dateTimeSunset.value = result.sunset;
    this.textboxRGB.value = result.rgb ? result.rgb : "";
    this.datetimepickerEndDate.value = result.endDate;
    this.datetimepickerEndDate_change();
    this.datetimepickerInoculationDate.value = result.inoculationDate;
    this._checkboxRunning.checked = result.running;
    if (result.strainName) this.textboxStrainName.value = result.strainName;
    if (result.medium) this.textboxMedium.value = result.medium;
    if (result.carbonSource) this.textboxCarbonSource.value = result.carbonSource;
    if (result.unit) this.textboxUnit.value = result.unit;
    if (result.acceptor) this.textboxAcceptor.value = result.acceptor;
    if (result.chromosome) this.textboxChromosome.value = result.chromosome;
    if (result.plasmids) this.textboxPlasmids.value = result.plasmids;
    if (result.dilution) this.textboxDilution.value = result.dilution;
    if (result.process) this.textboxProcess.value = result.process;
    if (result.od600) this.textboxOD600.value = result.od600;
    if (result.startingVolume) this.textboxStartingVolume.value = result.startingVolume;
    if (result.density) this.textboxDensity.value = result.density;
    if (result.aim) this.textareaAim.value = result.aim;
    if (result.cellBank) this.textboxCellBank.value = result.cellBank;
    if (result.streakDate) this.textboxStreakDate.value = result.streakDate;
    if (result.antibiotics) this.textboxAntibiotics.value = result.antibiotics;
    if (result.plateMedium) this.textboxPlateMedium.value = result.plateMedium;
    if (result.inoculums) {
      for (const row of result.inoculums) {
        this.datatableInoculums.appendChild(new Datatable.Row());
        for (const key in row) {
          this.datatableInoculums.lastElementChild.appendChild(new Textbox({
            value: row[key]
          }));
        }
      }
    }
    if (result.growthData) {
      for (const row of result.growthData) {
        this.datatableGrowthData.appendChild(new Datatable.Row());
        for (const key in row) {
          this.datatableGrowthData.lastElementChild.appendChild(new Textbox({
            value: row[key]
          }));
        }
      }
    }
    if (result.analyticalData) {
      /* flush rows, built table  */
      this.datatableAnalyticalData.innerHTML = "";

      /* build header */
      var header = this.datatableAnalyticalData.appendChild(new Datatable.Row());
      for (const key in result.analyticalData[0]) {
        header.appendChild(new Textbox({
          value: key
        }));
      }

      /* build content */
      for (const row of result.analyticalData) {
        this.datatableAnalyticalData.appendChild(new Datatable.Row());
        for (const key in row) {
          this.datatableAnalyticalData.lastElementChild.appendChild(new Textbox({
            value: row[key]
          }));
        }
      }
    }
  }
  constructor(...args) {
    _initProto(super(...args));
  }
  set fid(value) {
    this._fid = value;
  }
  get fid() {
    return this._fid;
  }
  async buttonSave_click(event) {
    var inoculums = [];
    for (let rows = this.datatableInoculums.children, header = rows[0].children, n = rows.length, i = 1; i < n; i++) {
      let row = {};
      for (var cells = rows[i].children, m = cells.length, j = 0; j < m; j++) {
        row[header[j].value] = cells[j].value;
      }
      inoculums.push(row);
    }
    var growthData = [];
    for (let rows = this.datatableGrowthData.children, header = rows[0].children, n = rows.length, i = 1; i < n; i++) {
      let row = {};
      for (let cells = rows[i].children, m = cells.length, j = 0; j < m; j++) {
        row[header[j].value] = cells[j].value;
      }
      growthData.push(row);
    }
    var analyticalData = [];
    for (let rows = this.datatableAnalyticalData.children, header = rows[0].children, n = rows.length, i = 1; i < n; i++) {
      let row = {};
      for (let cells = rows[i].children, m = cells.length, j = 0; j < m; j++) {
        row[header[j].value] = cells[j].value;
      }
      analyticalData.push(row);
    }
    console.log(this.datetimepickerInoculationDate.value);
    console.log(this.datetimepickerInoculationDate.value === null);
    var form = {
      id: this._textboxID.value,
      operator: this.textboxOperator.value,
      created: this.textboxCreated.value,
      targetTemperature: this._spinnerTargetTemperature.value,
      targetPH: this._spinnerTargetPH.value,
      pHDeadband: this.spinnerPHDeadband.value,
      feedRate: this._spinnerFeedRate.value,
      oxygenLevel: this._spinnerOxygenLevel.value,
      sunrise: this.dateTimeSunrise.value,
      sunset: this.dateTimeSunset.value,
      rgb: this.textboxRGB.value,
      airFlow: this._spinnerAirFlow.value,
      endDate: this.datetimepickerEndDate.value,
      inoculationDate: this.datetimepickerInoculationDate.value,
      running: this._checkboxRunning.checked,
      strainName: this.textboxStrainName.value,
      medium: this.textboxMedium.value,
      carbonSource: this.textboxCarbonSource.value,
      unit: this.textboxUnit.value,
      acceptor: this.textboxAcceptor.value,
      chromosome: this.textboxChromosome.value,
      plasmids: this.textboxPlasmids.value,
      dilution: this.textboxDilution.value,
      process: this.textboxProcess.value,
      od600: this.textboxOD600.value,
      startingVolume: this.textboxStartingVolume.value,
      density: this.textboxDensity.value,
      aim: this.textareaAim.value,
      cellBank: this.textboxCellBank.value,
      streakDate: this.textboxStreakDate.value,
      antibiotics: this.textboxAntibiotics.value,
      plateMedium: this.textboxPlateMedium.value,
      inoculums: inoculums,
      growthData: growthData,
      analyticalData: analyticalData
    };
    const resp = await fetch(`/api/pc/fermentations/${this._textboxID.value}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(form)
    });
    if (!resp.ok) throw new Error(`${resp.status}`);
    this.close();
  }
  buttonAddInoculum_click(event) {
    var row = this.datatableInoculums.appendChild(new Datatable.Row());
    for (var i = 0; i < this.datatableInoculums.firstElementChild.children.length; i++) row.appendChild(new Textbox());
  }
  buttonRemoveInoculum_click(event) {
    if (this.datatableInoculums.children.length < 2) {
      error("no more rows to delete");
      return;
    }
    this.datatableInoculums.removeChild(this.datatableInoculums.lastElementChild);
  }
  buttonAddGrowthData_click(event) {
    var row = this.datatableGrowthData.appendChild(new Datatable.Row());
    for (var i = 0; i < this.datatableGrowthData.firstElementChild.children.length; i++) row.appendChild(new Textbox());
  }
  buttonRemoveGrowthData_click(event) {
    if (this.datatableGrowthData.children.length < 2) {
      error("no more rows to delete");
      return;
    }
    this.datatableGrowthData.removeChild(this.datatableGrowthData.lastElementChild);
  }
  buttonAddAnalyticalData_click(event) {
    var row = this.datatableAnalyticalData.appendChild(new Datatable.Row());
    for (var i = 0; i < this.datatableAnalyticalData.firstElementChild.children.length; i++) row.appendChild(new Textbox());
  }
  buttonRemoveAnalyticalData_click(event) {
    if (this.datatableAnalyticalData.children.length < 2) {
      error("no more rows to delete");
      return;
    }
    this.datatableAnalyticalData.removeChild(this.datatableAnalyticalData.lastElementChild);
  }
  buttonAddProduct_click(event) {
    for (var i = 0; i < this.datatableAnalyticalData.children.length; i++) this.datatableAnalyticalData.children[i].appendChild(new Textbox());
  }
  buttonRemoveProduct_click(event) {
    if (this.datatableAnalyticalData.firstElementChild.children.length < 2) {
      error("no more products to delete");
      return;
    }
    for (var i = 0; i < this.datatableAnalyticalData.children.length; i++) this.datatableAnalyticalData.children[i].removeChild(this.datatableAnalyticalData.children[i].lastElementChild);
  }
  buttonClose_click(event) {
    this.close();
  }
  datetimepickerEndDate_change() {
    var duration = Math.round(moment.duration(moment(this.datetimepickerEndDate.value).diff(moment(new Date()))).asHours());
    this.spinnerDuration.value = duration > 0 ? duration : 0;
  }
  spinnerDuration_change() {
    this.datetimepickerEndDate.value = moment.utc(new Date()).add(this.spinnerDuration.value, 'hours').format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
  }
}